import * as Sentry from '@sentry/angular';
import { scrubRecordingEvent } from './sentry-scrubber';

/**
 * App chrome whose text is safe to show in session replays. Everything else stays masked
 * (maskAllText), so customer names, addresses and serials never reach Sentry. Add `.sentry-unmask`
 * to a static UI element to opt it in.
 */
export const SENTRY_UNMASK_SELECTORS: readonly string[] = [
    'fuse-vertical-navigation',
    'fuse-horizontal-navigation',
    'user-menu',
    'app-logo',
    'app-page-tabs',
    'th',
    'button',
    '[mat-dialog-title]',
    '.mat-mdc-tab',
    '.sentry-unmask'
];

/** The one replay configuration — used at init and when replay is added after a token page. */
export function createSentryReplay(): ReturnType<typeof Sentry.replayIntegration> {
    return Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: false,
        unmask: [...SENTRY_UNMASK_SELECTORS],
        // console/xhr breadcrumbs and network spans inside the recording never pass beforeSend
        beforeAddRecordingEvent: event => scrubRecordingEvent(event)
    });
}
